module.exports = __webpack_public_path__ + "static/wix_4-b30a54af0baeb636e084169108ce6289.png";